import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import App from './components/App';
import './i18n/config';
import './assets/css/tailwind.generated.css';
import './assets/css/main.css';

ReactDOM.render(
  <Router>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </Router>,
  document.getElementById('root')
);
